/*
  Памятка над каждой загрузкой: где взять файл и как он должен выглядеть.

  🔴 Указание владельца 18.09.2026: «нужно выбрать один конкретный отчёт или
  дать пример, в каком виде нужно, - и так для каждого. Твои подсказки вызывают
  ещё больше вопросов». До этого дня памятки говорили «выгрузите любым отчётом,
  где есть такие-то колонки» - то есть перекладывали на заказчика работу, ради
  которой он и покупает систему. Человек, впервые открывший 1С, из такой
  подсказки не узнаёт ни куда нажать, ни что должно получиться.

  Поэтому памятка всегда состоит из трёх частей, и ни одна не выбрасывается:

  1. **название отчёта в 1С** - ровно то, как он называется в конфигурации
     заказчика (проверено по копии его базы 18.09.2026, `docs/arch/onec-dump.md`);
  2. **как должен выглядеть файл** - шапка и две строки примера, видимые глазом;
  3. **кнопка «Скачать образец»** - тот же пример файлом, который можно открыть
     в Excel, заменить строки своими и загрузить обратно.

  Образец собирается ЗДЕСЬ ЖЕ из тех же строк, что показаны на экране: два
  описания одного и того же разъехались бы на первой правке, и человек скачивал
  бы файл, не похожий на картинку над кнопкой.

  🔴 Указание владельца 18.09.2026: памятка прячется под кнопкой с её же
  заголовком и по умолчанию свёрнута. Все три части остались на месте - но
  занимают они пол-экрана и стоят НАД полем выбора файла, а человеку, который
  грузит выгрузку второй раз в месяц, прокручивать их каждый раз незачем.
  Механика раскрытия - `Disclosure.jsx`, одна на все памятки раздела.
*/

import Disclosure from './Disclosure.jsx'

const SEPARATOR = ';'
/* Точка с запятой, а не запятая: Excel с русскими настройками открывает такой
   файл по колонкам сам, без мастера импорта. */

function csvOf({ headers, rows }) {
  return [headers, ...rows].map((line) => line.join(SEPARATOR)).join('\r\n')
}

function download(name, text) {
  /* Ссылка создаётся и нажимается на месте: файл собран в браузере, серверу о
     нём знать незачем. Кодировка с меткой порядка байтов - без неё Excel
     открывает русские заголовки как «Ëèöåâîé ñ÷¸ò». */
  const blob = new Blob([`\uFEFF${text}`], { type: 'text/csv;charset=utf-8' })
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = name
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(url)
}

export default function UploadHelp({ title, where, sample, note }) {
  return (
    <Disclosure title={title}>
      {where.map((line, index) => (
        <p key={index}>{line}</p>
      ))}

      <p className="muted">
        Заголовки колонок могут быть любыми - Арбитр ЖКХ узнаёт их по смыслу, а незнакомые
        вы сопоставите сами. Порядок колонок значения не имеет.
      </p>

      <div className="section__title section__title--spaced">Как должен выглядеть файл</div>
      <table className="table">
        <thead>
          <tr>
            {sample.headers.map((header) => (
              <th key={header}>{header}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {sample.rows.map((row, index) => (
            <tr key={index}>
              {row.map((cell, cellIndex) => (
                <td key={cellIndex}>{cell === '' ? <span className="muted">пусто</span> : cell}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>

      {note ? <p className="muted">{note}</p> : null}

      <div className="row row--tight">
        <button
          type="button"
          className="button button--quiet"
          onClick={() => download(sample.file, csvOf(sample))}
        >
          Скачать образец
        </button>
      </div>
    </Disclosure>
  )
}
